import request from './HttpService';
import { ENDPOINTS } from '../utils/constants';

export const exportData = async (
  type: string,
  screen: string,
  paginationInfo?: any,
  search?: any,
  uiHeadings?: any
) => {
  const { sortStatus, sort, filter, filterOp } = paginationInfo;
  let keys = filter;
  let opKeys = filterOp;
  try {
    if (filter?.length > 0) {
      keys = filter.join('|');
      if (filterOp?.length > 0) {
        opKeys = filterOp.join('|');
      }
    }

    return (
      (
        await request.post(ENDPOINTS.exportData(sortStatus, sort), {
          exportType: type,
          screen,
          uiHeadings,
          searchText: search?.toString(),
          filter: keys
            ?.toString()
            .replace(/inventoryVehicle./gi, 'inventoryVehicle_')
            .replace(/customerVehicle./gi, 'customerVehicle_')
            .replace(/prevAssgnChange./gi, 'prevAssgnChange_'),
          filterOp: opKeys?.toString(),
        })
      ).data || []
    );
  } catch (err) {
    console.log(err);
    return { data: [] };
  }
};
